import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';

interface ShortageFooterProps {
    onOpenWarehouse: () => void;
}

const ShortageFooter = ({ onOpenWarehouse }: ShortageFooterProps) => {
    const { t } = useTranslation(['Objects']);

    return (
        <div className="proposal-shortage__footer">
            <button
                type="button"
                className="proposal-shortage__link-btn"
                onClick={onOpenWarehouse}
            >
                <SolarIcon name="box-arrow-in-down" aria-hidden="true" />
                {t('proposalShortage.btnToWarehouse')}
            </button>
        </div>
    );
};

export default ShortageFooter;
